import * as React from "react";
import { useContext, useEffect, useState } from "react";

import { useAuth } from "../../../contexts/AuthContext.jsx";
import { alertV2 } from "../../../api/index.js";

import InfoDialog from "./InfoDialog.jsx";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { create } from "mathjs";
function ProceedRepair({
  data,
  alertId,
  openModal,
  setOpenModal,
  onSuccess,
  actionTaken,
  openWorkOrder,
  suspected,
}) {
  const [open, setOpen] = React.useState(false);
  const [textValue, setTextValue] = React.useState("");
  const [actionCompleted, setActionCompleted] = React.useState("Yes");
  const [actionWork, setActionWork] = React.useState("");
  const [additionalComment, setAdditionalComment] = React.useState("");
  const [other, setOther] = React.useState("");
  const [confirmedIssue, setConfirmedIssue] = React.useState("other");
  const { email } = useAuth();
  const [attachment, setAttachment] = useState("");
  const [attachmentName, setAttachmentName] = useState("");
  const [createWOrkOrder, setCreateWorkder] = useState("Yes");
  const handleChangeValue = (e) => {
    setTextValue(e.target.value);
  };
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
  };
  useEffect(() => {
    if (data) {
      setActionCompleted(data.action_completed);
      setAdditionalComment(data.additional_comment);
      setActionWork(data.action_work);
      setConfirmedIssue(data.confirmed_issue);
      setOther(data.confirmed_issue);
      setAttachmentName(data.attachment);
    } else {
      setActionCompleted("Yes");
      setAdditionalComment("");
      setActionWork("");
      setConfirmedIssue("other");
      setOther("");
      setAttachmentName("");
    }
  }, [data]);
  const submitHandler = async () => {
    const payload = {
      email: email,
      event_details: `Has responded to the alarm to ${actionTaken}. `,
      event_name: "Response",
      event_action: actionTaken,
      alert_id: alertId,
      action_detail: JSON.stringify({
        action_completed: actionCompleted,
        action_name: actionTaken,
        confirmed_issue: confirmedIssue === "other" ? other : confirmedIssue,
        action_work: actionWork,
        additional_comment: additionalComment,
      }),
    };
    const res = await alertV2.addLogAction(alertId, payload, attachment);
    onSuccess();
    setAttachmentName("");
    setActionCompleted("Yes");
    setAdditionalComment("");
    setActionWork("");
    setConfirmedIssue("other");
    setOther("");

    setOpenModal(false);
    setOpen(false);
    openWorkOrder();
  };
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  const handleAttachment = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setAttachment(undefined);
      return;
    }
    setAttachmentName(e.target.files[0].name);
    setAttachment(e.target.files[0]);
  };

  return (
    <div>
      <Modal show={open} size={"lg"} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Proceed with Maintenance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              fontSize: "13px",
              position: "relative",
              padding: "20px",
            }}
          >
            <div>
              1. Has the inpection been completed? <sup>*</sup>
            </div>
            <div style={{ marginLeft: "15px", position: "relative" }}>
              <div className="form-group mb-3">
                <div className="form-check form-check-inline">
                  <input
                    checked={actionCompleted === "Yes"}
                    onChange={(e) => setActionCompleted(e.target.value)}
                    className="form-check-input"
                    name="default_radio"
                    type="radio"
                    id="inlineRadio1"
                    value="Yes"
                    defaultValue="yes"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio1">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    onChange={(e) => setActionCompleted(e.target.value)}
                    name="default_radio"
                    checked={actionCompleted === "No"}
                    type="radio"
                    id="inlineRadio2"
                    value="No"
                    defaultValue="No"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    No
                  </label>
                </div>
              </div>
              {data ? <div className="overlay-disable"></div> : null}
            </div>
            <div style={{ marginTop: "5px" }}>
              <ol start={2} style={{ paddingLeft: "11px" }}>
                <li>
                  Please share with us the details of the inspection work done.
                  We recommend providing additional context. This will help us
                  in providing better recommendations in the future.
                </li>
              </ol>
            </div>
            <div style={{ padding: "5px 15px", position: "relative" }}>
              <textarea
                disabled={!!data}
                value={actionWork}
                placeholder="Please share more details here."
                onChange={(e) => setActionWork(e.target.value)}
                cols="30"
                rows="4"
                style={{
                  width: "100%",
                  resize: "none",
                  padding: "10px",
                  fontFamily: '"Source Sans Pro", sans-serif',
                  fontSize: "13px",
                }}
              ></textarea>
            </div>
            {!data ? (
              <div style={{ marginTop: "5px" }}>
                <input
                  type="file"
                  onChange={handleAttachment}
                  style={{ display: "none" }}
                  id="input-file-action"
                />
                <label
                  className="upload-docs"
                  htmlFor="input-file-action"
                  style={{
                    marginLeft: "15px",

                    cursor: "pointer",
                    border: "1px solid grey",
                    width: "240px",
                  }}
                >
                  {attachmentName ? (
                    attachmentName
                  ) : (
                    <div style={{ paddingTop: "3px", paddingLeft: "6px" }}>
                      Upload Maintenance Document{" "}
                      <i className="fa fa-paperclip"></i>
                    </div>
                  )}
                </label>
              </div>
            ) : null}

            <div style={{ marginTop: "5px" }}>
              3. Please select the confirmed issue.
            </div>
            <div style={{ position: "relative" }}>
              <div style={{ marginLeft: "15px" }}>
                <div className="form-group mb-3">
                  {suspected.map((item, index) => (
                    <div
                      className="form-check form-check-inline"
                      style={{ padding: "0" }}
                    >
                      <input
                        key={index}
                        value={item.name}
                        type="radio"
                        name="issue"
                        checked={confirmedIssue === item.name}
                        onChange={(e) => setConfirmedIssue(e.target.value)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio1"
                      >
                        {item.name}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              {/*<div style={{ marginLeft: "15px" }}>*/}
              {/*  <div className="form-control">*/}
              {/*    <div className="form-group mb-3">*/}
              {/*      <div*/}
              {/*        className="form-check form-check-inline"*/}
              {/*        style={{ padding: "0" }}*/}
              {/*      >*/}
              {/*        <input*/}
              {/*          checked={*/}
              {/*            confirmedIssue === "other" ||*/}
              {/*            suspected.find(*/}
              {/*              (item) => item.name === confirmedIssue*/}
              {/*            ) === undefined*/}
              {/*          }*/}
              {/*          onChange={(e) => setActionCompleted(e.target.value)}*/}
              {/*          className="form-check-input"*/}
              {/*          name="default_radio"*/}
              {/*          type="radio"*/}
              {/*          id="inlineRadio1"*/}
              {/*          value="other"*/}
              {/*          defaultValue="other"*/}
              {/*        />*/}
              {/*        <label*/}
              {/*          className="form-check-label"*/}
              {/*          htmlFor="inlineRadio1"*/}
              {/*        >*/}
              {/*          Others. Please specify:*/}
              {/*        </label>*/}
              {/*      </div>*/}
              {/*      {confirmedIssue === "other" ||*/}
              {/*      suspected.find((item) => item.name === confirmedIssue) ===*/}
              {/*        undefined ? (*/}
              {/*        <div style={{ paddingTop: "8px" }}>*/}
              {/*          <input*/}
              {/*            style={{*/}
              {/*              width: "250px",*/}
              {/*              height: "23px",*/}
              {/*              fontSize: "13px",*/}
              {/*              fontFamily: `"Source Sans Pro", sans-serif`,*/}
              {/*            }}*/}
              {/*            value={other}*/}
              {/*            onChange={(e) => setOther(e.target.value)}*/}
              {/*            type="text"*/}
              {/*          />*/}
              {/*        </div>*/}
              {/*      ) : null}*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</div>*/}
              <div>
                4. Create Work Order? <sup>*</sup>
              </div>
              <div style={{ marginLeft: "15px", position: "relative" }}>
                <div className="form-group mb-3">
                  <div className="form-check form-check-inline">
                    <input
                      checked={createWOrkOrder === "Yes"}
                      onChange={(e) => setCreateWorkder(e.target.value)}
                      className="form-check-input"
                      name="default_radio2"
                      type="radio"
                      id="inlineRadio1"
                      value="Yes"
                      defaultValue="yes"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      checked={createWOrkOrder === "No"}
                      onChange={(e) => setCreateWorkder(e.target.value)}
                      className="form-check-input"
                      name="default_radio2"
                      type="radio"
                      id="inlineRadio2"
                      value="No"
                      defaultValue="No"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio2">
                      No
                    </label>
                  </div>
                </div>
                {data ? <div className="overlay-disable"></div> : null}
              </div>
              {data ? <div className="overlay-disable"></div> : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="theme" onClick={submitHandler}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default ProceedRepair;
